export class LotteryTask
{
 
    public  id: string;
    public taskType:number;
    public createDate:number;
    public status:number;
    public finishDate:number;
    public data:any;
    public totalSteps:number;
    public currentStep:number;
    public forceFinish: boolean;
    public  maxGenerateBets: number;
    public   stopGenerateBets: number;
    public filterOn: boolean;
  
    public action: number;
    public stopDescription: string;
    public description: string;
    public betId: string;
    public lotteryId: string;
    public userId: string;
    public deviceType: string;
}

export enum LotteryTaskStatuses
{
    Waiting = 0,
    WaitingDescription  = <any>"Aguardando",
  
    Processing = 1,
    ProcessingDescription  = <any>"Processando", 
     Saving = 2,
    SavingDescription  = <any>"Salvando",
    Success=10,
    SuccessDescription  = <any>"Finalizada com sucesso",
    Cancel=90,
    CancelDescription  = <any>"Cancelada",
    Abort=91,
    AbortDescription  = <any>"Abortada",
    Error = 99,
    ErrorDescription  = <any>"Finalizada com erro",

}

export enum OrderStatus
{  
    WaitingPayment = 0,
    WaitingPaymentDescription  = <any>"Aguardando confirmação",
  
    Paied = 2,
    PaiedDescription  = <any>"Pagamento Confirmado",

    Error = 101,
    ErrorDescription  = <any>"Erro de pagamento",
 
    Expirated = 102,
    ExpiratedDescription  = <any>"Prazo de pagamento Expirado",

}


export enum TaskActions
{
   
    Cancel=1,
    CancelDescription  = <any>"Cancelada",
    Stop=2,
    StopDescription  = <any>"Interromper",
   

}


